/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const CashDrawerChangeType = {
  AddCash: "ADD_CASH",
  RemoveCash: "REMOVE_CASH",
  Purchase: "PURCHASE",
  Refund: "REFUND",
  Count: "COUNT",
} as const;

export type CashDrawerChangeType =
  (typeof CashDrawerChangeType)[keyof typeof CashDrawerChangeType];

export type CashDrawerChangeTypeEnumType = typeof CashDrawerChangeType;
export type CashDrawerChangeTypeOptional = CashDrawerChangeType;
export type CashDrawerChangeTypeTrackedI = CashDrawerChangeType;
export type CashDrawerChangeTypeTracked = CashDrawerChangeType;
export type CashDrawerChangeTypeMetaI = EnumMetaType<
  CashDrawerChangeTypeEnumType,
  CashDrawerChangeType
>;
export const CashDrawerChangeTypeMeta = typeMetaEnum<
  CashDrawerChangeTypeEnumType,
  CashDrawerChangeType
>("CashDrawerChangeType", CashDrawerChangeType);
export function transformDatesCashDrawerChangeType(
  model: CashDrawerChangeType,
) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
